module.exports = __webpack_public_path__ + "img/orderlist.b52f1cc7.png";